export const getUserById = (users, userId) => {
    const user = users.find(user => (
        user.id === userId
    ))

    return user;
}

export const getMentionableUsers = applicableUsers => {
	let userMentions = []

    applicableUsers.forEach(user => {
        const userName = user.first_name+' '+user.last_name

        const userMention = {
            text: userName,
            value: userName,
            url: '#mention-'+user.id,
            id: user.id
        }

        userMentions.push(userMention)
    })

    return userMentions
}

export const getMeta = (user, type, account = null) => {
    if(!user){
        return null
    }

    let key = ''

    switch(type){
        case 'role':
            key = 'roles'
            break
        case 'hoursWorked':
            key = 'hours_worked'
            break
    }
    
    const accountId = account ? account.id : user.last_open_account_id

    let response = null

    if(user[key] && user[key][accountId]){
        response = user[key][accountId]
    }else{
        switch(type){
            case 'role':
                response = user.role
                break
            case 'hoursWorked':
                response = 38
                break
        }
    }

    return response
}